import type { HomePageEndpointResponse } from '@ps/isp-web-services-types';
import produce from 'immer';

import type { EventTypeId } from '@swf/sports/types/eventType';

import { defaultState } from './defaultState';

type State = typeof defaultState;

export const reducers = {
  clear: (): State => produce(defaultState, (draft) => draft),
  homePageRequested: (state: State): State => ({
    ...state,
    isLoading: true
  }),
  setPopularAccumulatorsSelectedEventType: (state: State, payload: EventTypeId): State => ({
    ...state,
    popularAccumulatorsSelectedEventType: payload
  }),
  homePageLoadSuccess: (state: State, payload: HomePageEndpointResponse): State => {
    let { popularAccumulatorsSelectedEventType } = state;
    const validEventTypes = payload.popularAccumulators.map(
      (pacca) => payload.markets[pacca.runnerIds[0].marketId].eventTypeId
    );

    if (
      (!popularAccumulatorsSelectedEventType && payload.popularAccumulators.length) ||
      (popularAccumulatorsSelectedEventType &&
        !validEventTypes.includes(popularAccumulatorsSelectedEventType))
    ) {
      const market = payload.markets[payload.popularAccumulators[0].runnerIds[0].marketId];
      popularAccumulatorsSelectedEventType = market.eventTypeId;
    }

    return {
      ...state,
      ...payload,
      isLoading: false,
      hasPreloaded: true,
      popularAccumulatorsSelectedEventType
    };
  },
  homePageLoadFailure: (state: State): State => ({
    ...state,
    isLoading: false,
    hasPreloaded: true,
    error: true
  })
};
